import filterVsbInitiateIdentityValueResponse from '../../helpers/filter-vsb-initiate-identity-value-response';
import initiateIdentityValidation from '../initiate-identity-validation';

/*
 * Buttonless wrapper for initiateIdentityValidation api.
 * This is what is bound to "V" namespace for merchant to
 * call in integrated Vsb flows. Wrapper is needed to keep
 * integrated/buttonless specific logic and response handling
 * separate from initiateIdentityValidation orch api
 */
const initiateIdentityValidationForButtonless = data => {
  return new Promise(resolve => {
    initiateIdentityValidation(data).then(result => {
      resolve(filterVsbInitiateIdentityValueResponse(result));
    });
  });
};

export default initiateIdentityValidationForButtonless;
